import {
  Flex,
  FormTimeInput,
  type FormTimeInputProps,
  ReadonlyField,
  type ReadonlyFieldProps,
  Text,
  WatchLaterOutlinedIcon,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import { type BaseViewModeProps, type BaseInputModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormTimeInputProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content' | 'maxLines'>>;

export type TimeInputRendererProps = InputModeProps | ViewModeProps;

export default function TimeInputRenderer(props: Readonly<TimeInputRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;
      return <FormTimeInput name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      const { ...readonlyFieldProps } = slotProps || {};
      return (
        <ReadonlyField
          content={
            <Flex
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text component='span'>{value}</Text>
              <WatchLaterOutlinedIcon sx={(theme) => ({ color: theme.palette.text.secondary })} />
            </Flex>
          }
          {...readonlyFieldProps}
        />
      );
    }
  }
}
